// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"bfecb89e","630":"c286908e","641":"56e2d1fb","865":"45de7a97","989":"e9d5e9c6"}[chunkId] + ".chunk.js";
};